export const SENTRY_DSN = 'https://b75a765e71264d7387be8b50335e8d2d@o99218.ingest.sentry.io/4505319015448576';

export function sentryEnvironment(hostname = window.location.hostname): string {
  if (hostname.includes('local')) {
    return 'local';
  } else if (hostname.includes('dev') || hostname.includes('int')) {
    return 'integration';
  } else if (hostname.includes('stage') || hostname.includes('uat')) {
    return 'user-acceptance';
  } else {
    return 'production';
  }
}

// The app initializes Sentry once it has started, so a startup failure needs its own client.
export function reportStartupError(error: unknown, release: string): Promise<void> {
  return import('@sentry/react')
    .then(Sentry => {
      if (!Sentry.getClient()) {
        Sentry.init({
          dsn: SENTRY_DSN,
          environment: sentryEnvironment(),
          release: release || undefined,
        });
      }
      Sentry.captureException(error, { tags: { startup: true } });
    })
    .catch(reportError => console.error('Could not report the startup error to Sentry:', reportError));
}
